import { CSP_NONCE, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './app/environments/environment';
// Import a function which adds the web components to the window
import { defineCustomElements as defineCustomUpsElements } from '@ux/components/loader';

// Register the UPS web components
defineCustomUpsElements(window);

// Extract nonce from meta tag
const nonceElement = document.querySelector('meta[name="csp-nonce"]');
const nonceValue = nonceElement?.getAttribute('content') || '';
console.log('CSP Nonce Value used:', nonceValue);
console.log('sci deployment issue');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    providers: [{ provide: CSP_NONCE, useValue: nonceValue }],
  })
  .catch((err) => console.error(err));
